<template>
	<div class="chair">
		<div class="maincontent__double-header-wrapper">
			<div class="maincontent__double-header">
				<h2 class="maincontent__double-header-title">Fotel</h2>
				<h2 class="maincontent__double-header-unit unit-model-header">
					<small>Unit stomatologiczny</small>
					<br />
					{{ unit.fullName }}
				</h2>
			</div>
		</div>

		<div class="chair__row chair__row--headers">
			<div class="chair__col chair__col--left">
				<h4 class="header-with-hint">Wybierz model fotela</h4>
				<div>Wybierz jedną opcję:</div>
			</div>
			<div class="chair__col chair__col--right">
				<h4 class="header-with-hint">Akcesoria fotela</h4>
				<div>Wybierz dowolne</div>
			</div>
		</div>

		<div
			v-for="chair in getAppData('chairsList')"
			class="chair__row chair__row--chair"
			:key="chair.name"
		>
			<div class="chair__col chair__col--left">
				<div
					:class="{
						'chair__chair-select': true,
						'chair__chair-select--selected': chair.name === selectedChairName,
					}"
					@click="selectChair(chair)"
				>
					<img :src="require(`@/assets/pictures/${chair.image}`)" />
					<div class="chair__radio">
						<span
							:class="['chair__radio-checkmark', {'--checked': chair.name == selectedChairName}]"
						></span>
						{{ chair.fullName }}
						<div style="margin-top: 5px" v-if="chair.cost">
							{{ formatPrice(chair.cost) }}
						</div>
					</div>
				</div>
			</div>

			<div class="chair__col chair__col--right">
				<div class="chair__chair-accessories">
					<Radio
						v-for="acc in appData.getChairAccessories(unit.name, chair.name)"
						name="accessories"
						:key="acc.name"
						:value="acc.name"
						@change="onPickAccessory($event, chair.name, acc)"
						:checked="chair.name === selectedChairName && selectedAccessories.includes(acc.name)"
						:multiple="true"
						:checkbox="true"
					>
						{{ acc.fullName }}
						<span class="chair__radio-cost" slot="right-addon">
							{{ formatPrice(acc.cost) }}
						</span>
					</Radio>
				</div>
			</div>
		</div>

		<div class="chair__chair-accessories-mobile" v-if="availableAccessories.length">
			<h4 class="header-with-hint">Akcesoria fotela</h4>
			<div>Wybierz dowolne</div>
			<div class="chair__chair-accessories chair__chair-accessories-mobile-content">
				<Radio
					v-for="acc in availableAccessories"
					name="accessories"
					:key="acc.name"
					:value="acc.name"
					@change="onPickAccessory($event, selectedChairName, acc)"
					:checked="selectedAccessories.includes(acc.name)"
					:multiple="true"
					:checkbox="true"
				>
					{{ acc.fullName }}
					<span class="chair__radio-cost" slot="right-addon">
						{{ formatPrice(acc.cost) }}
					</span>
				</Radio>
			</div>
		</div>

		<div class="chair__col">
			<div class="chair__row chair__row--headers">
				<div>
					<h4 class="header-with-hint">Fotelik lekarza</h4>
					<div>Możesz wybrać dowolną liczbę</div>
				</div>
			</div>
			<Radio
				class="chair__option-radio"
				v-for="physicianChair in physicianChairs"
				name="chair-mast"
				:value="physicianChair.name"
				@change="updatePhysicianChairs"
				:checked="selectedChairs.includes(physicianChair.name)"
				:key="physicianChair.name"
				:checkbox="true"
				:emitValueOnUncheck="true"
			>
				<span class="chair__radio-label">
					{{ physicianChair.fullName }}
				</span>
				<span class="chair__radio-cost" slot="right-addon">
					{{ formatPrice(physicianChair.cost) }}
				</span>
			</Radio>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import {mapState} from 'vuex';
import AppDataMixin from '@/mixins/app-data';
import Radio from '@/components/Radio';

export default {
	name: 'Chair',
	components: {Radio},
	mixins: [AppDataMixin],
	data() {
		return {
			physicianChairs: [],
		};
	},
	computed: {
		...mapState('unitConfiguration', {selectedChairs: 'physicianChairs'}),
		selectedChairName() {
			return this.$store.state.unitConfiguration.chair;
		},
		selectedAccessories() {
			return this.$store.state.unitConfiguration.chairAccessories;
		},
		availableAccessories() {
			return this.appData.getChairAccessories(this.unit.name, this.selectedChairName);
		},
		selectedPhysicianChair() {
			return this.$store.getters['unitConfiguration/data']('physicianChair').name;
		},
	},
	methods: {
		selectChair(chair) {
			this.$store.commit('unitConfiguration/setChair', chair.name);
		},
		onPickAccessory(checked, chairName, accessory) {
			if (chairName !== this.selectedChairName) {
				return;
			}

			const mutuallyExclusiveNames = R.pipe(
				R.filter(R.propEq('group', 'group-01')),
				R.pluck('name')
			)(this.availableAccessories);

			const isAccessoryExclusive = R.propEq('group', 'group-01', accessory);

			const accessories = checked
				? R.pipe(
						R.when(() => isAccessoryExclusive, R.without(mutuallyExclusiveNames)),
						R.append(accessory.name),
						R.uniq
				  )(this.selectedAccessories)
				: R.without([accessory.name], this.selectedAccessories);

			this.$store.commit('unitConfiguration/setChairAccessories', accessories);
		},
		updatePhysicianChairs(physicianChair) {
			const newPhysicianChairs = this.selectedChairs.includes(physicianChair)
				? R.without([physicianChair], this.selectedChairs)
				: R.pipe(R.append(physicianChair))(this.selectedChairs);

			this.$store.commit('unitConfiguration/setPhysicianChairs', newPhysicianChairs);
		},
	},
	mounted() {
		this.physicianChairs = this.getAppData('physicianChairs');
	},
};
</script>
